/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const ICONS = {
    drag: "drag",
};
export const SLOTS = {
    actionsEnd: "actions-end",
    actionsStart: "actions-start",
};
//# sourceMappingURL=resources.js.map
